import { React, useRef, useState } from "react";
import { Link } from "react-router-dom";
import parse from 'html-react-parser'

function ProductGallery(props) {
  let [taber, settaber] = useState(0)
  let [toggle, setToggle] = useState(false)
  var  imagesCount = props.images? (JSON.parse(props.images).length -1):0;
  var discount = props.discount? props.discount:0;
  var featured = props.featured? props.featured:0;
  let handleClick = () => {
    //setToggle(!toggle)
    //alert(toggle)
    setToggle(current => !current);
  }
  let scrollTop = (e, v) => {
    let h = window.innerHeight;
    let y = e.clientY - h / 2;
    //alert(h +'===' +e.clientY +'--'+y)
    //alert(h +'===' +e.clientY +'--'+y+'==='+v)
    //return v + y * 0.1;
    
  }

  const containerRef = useRef(null);
  const handleMouseMove2 = (e) => {
    if (containerRef.current) {
      const container = containerRef.current;
      const windowHeight = window.innerHeight;
      const mouseY = e.clientY - windowHeight / 2;
      container.scrollTop += mouseY * .1;
    }
  } ;

//form img zoom
const [hoveredImage, setHoveredImage] = useState(null);
const [backgroundPosition, setBackgroundPosition] = useState({ x: 0, y: 0 });

const handleMouseMove = (e, i) => {
  const { left, top, width, height } = e.target.getBoundingClientRect();
  const x = ((e.clientX - left) / width) * 100; // Use clientX
  const y = ((e.clientY - top) / height) * 100; // Use clientY
  setBackgroundPosition({ x, y });
  setHoveredImage(i); // Set the hovered image index
};

const handleMouseLeave = () => {
  setHoveredImage(null); // Remove zoom when mouse leaves
};
  //end img zoom


  return (
            <>
            <div className="main_product_image">
                {discount > 0 && <span className="onsale">Sale!</span> }
                {featured === 1 && (
                  <span className="best_seller">Best Seller</span>
                )}
                <div className="product-images">
                
                {/* {props.images && JSON.parse(props.images)?.map((imgs,i)=>{
                return( 
                  <>
                 <a href="javascript:void(0)" key={i} className={taber === i ? 'active' : null} onClick={() => { settaber(i); handleClick(); }}><span><img src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/${imgs}`} alt={i+1} /></span></a>
                  
                  </>
                  )
                })
                }  */}

{props.images &&
        JSON.parse(props.images)?.map((imgs, i) => {
          return (
            <div className="img-container-zoom">
              <a
                href="javascript:void(0)"
                className={taber === i ? 'active' : null} onClick={() => { settaber(i); handleClick(); }}
                onMouseMove={(e) => handleMouseMove(e, i)}
                onMouseLeave={handleMouseLeave}
              >
                <span>
                  <img
                    src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/${imgs}`}
                    alt={`Product ${i + 1}`}
                    className="thumbnail-image"
                  />
                </span>
              </a>

              {/* Show the zoomed image on hover */}
              {hoveredImage === i && (
                <div
                  className="zoomed-image-container"
                  style={{
                    backgroundImage: `url(${process.env.REACT_APP_API_ROOT}/storage/app/public/product/${imgs})`,
                    backgroundPosition: `${backgroundPosition.x}% ${backgroundPosition.y}%`,
                  }}
                ></div>
              )}
            </div>
          );
        })}
                
                {props.short_video &&
                  <a href="javascript:void(0)" className="product-video-box">
                    <span><video className={taber === imagesCount+1 ? 'active' : null} onClick={() => { settaber(imagesCount+1); handleClick(); }} preload="none" loop="true" width="720" height="1280" autoplay="true" playsinline="true" muted="true" mediatype="video" issafari="false" isimagemedia="false" src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/chaashni-short-video/${props.short_video}`}></video></span>
                  </a>
                }
                

                </div>

                <div className={toggle ? 'product-images-overlay product-overlay-active' : 'product-images-overlay '}>
                  <div className={toggle ? 'product-images-pop product-pop-active' : 'product-images-pop'}>
                    <a className="product-images-close" href="javascript:void(0)" onClick={() => { handleClick(); }}> × </a>

                    <div className="product-images-tabs">
                    {props.images && JSON.parse(props.images)?.map((imgs,i)=>{
                    return( 
                      <>
                      <a href="javascript:void(0)"  key={i} className={taber === i ? 'active' : null} onClick={() => settaber(i)} data-id={`img-${i+1}`}><img src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/thumbnail/${imgs}`} alt={i+1} /></a>
                      </>
                        )
                      })
                      } 
                      {props.short_video &&
                       <a href="javascript:void(0)"  key={imagesCount+1} className={`video-icon-box ${taber === imagesCount+1 ? 'active' : null}`} onClick={() => settaber(imagesCount+1)} data-id={`img-${imagesCount+1+1}`}><img className="video-button" src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/thumbnail/${props.images && JSON.parse(props.images)[0]}`} alt={imagesCount+1} /></a>
                      }
                    </div>

                    <div className="product-images-direction">

                      <a href="javascript:void(0)" className="pro-prev" onClick={() => taber <= 0 ? settaber(props.long_video?imagesCount+1:imagesCount) : settaber(taber - 1)}>&lt;</a>

                      <a href="javascript:void(0)" className="pro-next" onClick={() => taber >= (props.long_video?imagesCount+1:imagesCount) ? settaber(0) : settaber(taber + 1)}>&gt;</a>

                    </div>
                    <div className="product-images-content"  onMouseMove={handleMouseMove2} ref={containerRef} style={{ overflowY: 'auto', height: 'calc(100vh - 40px)'}}>
                      
                    {props.images && JSON.parse(props.images)?.map((imgs,i)=>{
                    return( 
                      <>
                      {taber === i ? <img key={i} src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/${imgs}`} alt={i+1} id={`img-${i+1}`} className="product-content-image active" onMouseOver={(e) => scrollTop(e)} /> : null}
                      </>
                        )
                      })
                      }
                      
                      {props.long_video && taber === imagesCount+1 ? 
                       <video id={`img-${imagesCount+1+1}`} preload="none" key={imagesCount+1+1} loop="true" width="375" height="540" autoplay="true" playsinline="true" muted="true" mediatype="video" className="svelte-jk0m5r" jsonkey="LQpQ74Z2fP" issafari="false" isimagemedia="false" src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/chaashni-long-video/${props.long_video}`}></video>
                       : null}
                     
                    </div>
                  </div>
                </div>
              </div>
            </>            
  );
}

export default ProductGallery;
